@if (model?.data) {
<div class="w-12 ratio-product-image pos-relative"
     [style.aspectRatio]="model.isLandscapeListingView | aspectRatio : gridRowSpan : gridColumn">
    @if (model.displayDiscount && labelDiscount) {
    <product-discount-label class="pos-absolute z-2"
                            [class]="listingSize() === 1 ? 'bottom-4 left-4' : 'left-1 bottom-1 left-2-m left-2-s bottom-2-m bottom-2-s'"
                            [product]="model" />
    }
    <product-image [model]="model" />
    <product-listing-wishlist [product]="currentColorProduct || model"
                              [color]="currentColor"
                              [listPosition]="listPosition" />
</div>
<product-listing-add-to-basket-exp class="block"
                                   [listingSize]="listingSize()"
                                   [product]="model"
                                   [configurableSelection]="configurableSelection"
                                   [wishlistItem]="wishlistItem()"
                                   [buyRequest]="request"
                                   [canAdd]="canShowAddToBasket"
                                   [listPosition]="listPosition"
                                   [color]="currentColor"
                                   [gtmTrackClick]="{category: 'PLP', action: 'Quick Add button click', label: model.data.name}"
                                   [context]="wishlistCarouselItem() ? 'wishlist' : undefined" />
<div class="pos-relative flex flex-justify-between flex-grow _bottom-section p-t-1"
     cy-listingProductName
     [class.no-label]="!shortLabel || hideLabel()">
    <div class="flex p-r-1 pos-relative _bottom-section-inner">
        <div class="w-12 flex-column">
            <href class="flex-column flex-grow left"
                  [link]="hrefLink()"
                  [gtmTrackSelectItem]="gtmTrackSelectItem"
                  [gtmTrackSelectItemOff]="app.client.isCms"
                  [klevuTrackCategoryProductClick]="klevuCategoryProductTrackClick()"
                  [klevuTrackClick]="klevuSearchTrackClick()">
                <!-- name & price -->
                <div class="col-1 p1 p-b-1"
                     [class.ng-hide]="computedHideNameAndPrice()">

                    <!-- name -->
                    <div *abIf="'(plpProductName) A'"
                         [class.ng-hide]="computedHideName()">{{computedProductName()}}</div>
                    <div *abIf="'(plpProductName) B'"
                         [class.ng-hide]="computedHideName()"
                         class="_product-name">{{computedProductName()}}</div>

                    <!-- price -->
                    <div [class.ng-hide]="computedHidePrice()">
                        @if (currentOrgPrice()) {
                        <price class="p-r-1 inline-block line-through col-13 price"
                               [class.hidden]="computedHidePrice()"
                               [sizeClass]="'XL: p1, MS:p2'"
                               [value]="currentOrgPrice()" />
                        }
                        <price class="inline-block price fw-bold"
                               [value]="currentPrice()" />
                    </div>
                </div>
                @if (model.isOutOfStock && wishlistCarouselItem() && !emailMeWhenInStock) {
                <p class="col-2"
                   [sizeClass]="'XL: p1, MS:p2'">{{'Out of stock' | translate}}</p>
                }
                <div>
                    @if (computedColors()) {
                    @if (!computedIsAccountPage() && !computedIsSearchOutlet()) {
                    <div class="flex flex-middle">
                        <div class="flex flex-middle flex-wrap _colors">
                            @for (color of computedColorsSlice(); track color) {
                            <swatch class="m-r-1 m-t-1-s m-t-1-m inline-block"
                                    [color]="color"
                                    [selected]="currentColor === color"
                                    (mouseenter)="setColourWithDelay(color)"
                                    (click)="currentColor = color" />
                            }
                        </div>
                        @if (computedColors() && computedColors()!.length > 3) {
                        <div class="flex flex-wrap _colors">
                            <button class="m-t-1-s m-t-1-m"
                                    type="button">+</button>
                        </div>
                        }
                    </div>
                    }
                    }
                    <ng-container *abIf="'(productReviews) B'">
                        @if (model.reviewsCount > 0) {
                        <div class="m-t-1 p-b-1 flex flex-middle">
                            <rating class="col-12 flex flex-middle"
                                    [value]="model.reviewsRating" />
                            <p class="col-12"
                               [sizeClass]="'XL: p1, MS:p2'">
                                ({{model.reviewsCount}})
                            </p>
                        </div>
                        }
                    </ng-container>
                </div>
            </href>
            <!-- label -->
            @if (!computedHideLabel()) {
            <listing-label [customClass]="'c1 left uppercase col-12'"
                           [product]="model"
                           [displayDefault]="true" />
            }
        </div>
    </div>
</div>
}